/**
 * @file FooterAboutCard.tsx
 * @description Карточка «О магазине · всегда первая» в «Меню → Подвал»
 * (phase19.16, приёмка Р2а; SB114; uiux-footer-columns §4.6, §4.7, §5):
 * закреплена (не перетаскивается), показывает, из чего собрана, а
 * настраивается во вкладке «Подвал» шапки и подвала.
 */

import { Lock } from "lucide-react";
import { Link } from "react-router";

interface Props {
  /** «лого, слоган, подпись»; null — показать нечего (на сайте колонки нет). */
  summary: string | null;
  /** Вкладка «Шапка и подвал → Подвал». */
  href: string;
}

export function FooterAboutCard({ summary, href }: Props) {
  return (
    <section aria-label="Колонка «О магазине»" className="flex flex-col gap-1 rounded-xl bg-surface-low p-3">
      <span className="type-card-title inline-flex items-center gap-2 text-on-surface">
        <Lock aria-hidden className="size-4 text-on-surface-variant" />
        О магазине · всегда первая
      </span>
      <span className="type-body text-on-surface-variant">
        {summary ? `${summary.charAt(0).toUpperCase()}${summary.slice(1)}` : "Сейчас пусто — на сайте колонки нет"}
      </span>
      <span className="type-caption flex flex-wrap items-center gap-x-1 text-on-surface-variant">
        Что в ней — во вкладке «Подвал».
        <Link to={href} className="inline-flex min-h-12 items-center font-medium text-primary hover:underline">
          Открыть →
        </Link>
      </span>
    </section>
  );
}
